import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const updateList = (list, newValue) => {
  const position = list.findIndex((element) => element.code === newValue.code);
  const newList = [...list];
  if (position === -1) {
    newList.push(newValue);
    return newList;
  }
  newList[position] = newValue;
  return newList;
};

export const users = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_USER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USER]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [...updateList(state.list, action.response.data)],
    }),
    [ActionTypes.FETCHED_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.GET_USERS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_USERS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_USERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
